import React from 'react'

import { ImgSanity } from '@slite/components'

import { Section } from '../../components/Section'

export const SectionQuote = ({
  quote,
  authorImageUrl,
  authorTitle,
  authorDescription,
  background = 'saturn-orange',
}: {
  quote: string
  authorImageUrl: string
  authorTitle: string
  authorDescription: string
  background?: string
}) => {
  return (
    <Section
      containerTopPadding={24}
      containerBottomPadding={24}
      background={background}
    >
      <div className="grid-12">
        <div className="shade-100 grid-span-8 grid-offset-2">
          <p className="margin-bottom-32 font-size-4 font-family-title text-align-center">
            {quote}
          </p>

          <div className="flexbox flexbox-align-center flexbox-column-gap-16 flexbox-centered">
            <ImgSanity
              style={{ width: 56 }}
              className="radius-round"
              alt={authorTitle}
              src={authorImageUrl}
            />
            <div>
              <div className="font-weight-semibold">{authorTitle}</div>
              <div className="opacity-large">{authorDescription}</div>
            </div>
          </div>
        </div>
      </div>
    </Section>
  )
}
